export default __webpack_public_path__ + "static/media/remove_assignee_black.860f31c7.svg";